<template>
  <div>
    <v-list-item v-for="oferta in pacote.ofertas" :key="oferta.id">
      <v-list-item-avatar class="square-avatar">
        <px-oferta-foto height="40"
                        width="40"
                        :foto="oferta.oferta.foto"/>
      </v-list-item-avatar>
      <v-list-item-content class="list-item-oferta-title">
          <span class="body-1">
            <px-codigo-interno :codigo-interno="oferta.oferta.codigoInterno"/>
            {{ oferta.tituloProduto }}
          </span>
        <div>
          <px-show-variacoes-completo :variacoes="oferta.variacoes"/>
        </div>
        <div>
          <px-especificacao-oferta :especificacao="oferta.especificacaoProduto"/>
        </div>
      </v-list-item-content>
      <v-list-item-content>
          <span class="body-2">
            <px-compras-produtos-preco :oferta="oferta"/>
          </span>
      </v-list-item-content>
      <v-list-item-content v-if="hasAnyIpi">
        <px-compras-produtos-ipi :oferta="oferta"/>
      </v-list-item-content>
      <v-list-item-content v-if="hasValorAdicional(pacote)">
        {{ oferta.valorAdicional | currency }}
        <div class="caption">
          valor adicional
        </div>
      </v-list-item-content>
      <v-list-item-content class="font-weight-bold body-2">
        {{ oferta.total | currency }}
        <div class="caption">
          total
        </div>
      </v-list-item-content>
      <v-list-item-action>
        <px-open-oferta is-marketplace :oferta="oferta.oferta"/>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>
<script>
import pxComprasProdutosPreco
  from '@/modules/marketplace/compras/detalhes/ComprasProdutosPreco.vue';

export default {
  props: {
    pacote: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasAnyIpi() {
      return (pacote) => pacote.ofertas.some((oferta) => oferta.ipi && oferta.ipi.destacar);
    },
    hasValorAdicional() {
      return (pacote) => pacote.ofertas.some((oferta) => !!oferta.valorAdicional);
    },
  },
  components: { pxComprasProdutosPreco },
};
</script>


<style scoped>
.list-item-oferta-title {
  min-width: 35%;
}
</style>
